import { styled } from '@mui/material/styles';
import ResourceTable, { IColumn } from '../components/ResourceTable';
import { IFilterField } from 'models/types';
import { AuditLogDto } from 'models/dtoTypes';
import { GetPaginatedAuditLogs } from 'services/openapiClient';
import { date2str } from 'utils/date';

const PREFIX = 'ActivitiesPage';

const classes = {
  root: `${PREFIX}-root`,
  demo: `${PREFIX}-demo`,
};

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(5),
  width: '100%',

  [`&.${classes.demo}`]: {
    backgroundColor: theme.palette.background.paper,
  },
}));

const columns: IColumn<AuditLogDto>[] = [
  {
    label: 'Event',
    dataIndex: 'eventName',
  },
  {
    label: 'Controller',
    dataIndex: 'controllerName',
  },
  {
    label: 'Created',
    dataIndex: 'created',
    sortIndex: 'created',
    render: (auditLog) => {
      return date2str(auditLog.created, 'DD MMM YYYY, HH:mm:ss');
    },
  },
  {
    label: 'User',
    render: (auditLog) => {
      const user = auditLog.user;
      if (user) {
        return <>{user.email}</>;
      } else {
        return <>{auditLog.aadUserId}</>;
      }
    },
  },
];

const filterSchema: IFilterField[] = [
  {
    label: 'Action Name',
    name: 'actionName',
    widget: 'text',
  },
  {
    label: 'User',
    name: 'aadUserId',
    widget: 'userSelect',
  },
  {
    label: 'Period',
    name: 'createdMonth',
    widget: 'monthPicker',
  },
];

export default function ActivitiesPage(): JSX.Element {
  return (
    <Root>
      <h2>Activities</h2>
      <ResourceTable
        filterSchema={filterSchema}
        columns={columns}
        onFetch={GetPaginatedAuditLogs}
        defaultSort={{
          sortColumn: 'created',
          isDesc: true,
        }}
      />
    </Root>
  );
}
